import { call, put, takeLatest, select } from 'redux-saga/effects';
import queryMonitoringService from '../../../services/queryMonitoringService';
import {
    fetchDashboard,
    fetchDashboardSuccess,
    fetchDashboardFailure,
    fetchQueryHistory,
    fetchQueryHistorySuccess,
    fetchQueryHistoryFailure,
    fetchAlerts,
    fetchAlertsSuccess,
    fetchAlertsFailure,
    configureAlert,
    configureAlertSuccess,
    configureAlertFailure,
    updateAlert,
    updateAlertSuccess,
    updateAlertFailure,
    deleteAlert,
    deleteAlertSuccess,
    deleteAlertFailure,
    exportReport,
    exportReportSuccess,
    exportReportFailure,
    selectFilters,
} from './sliceTab5';

// Helper to get current filters from state
function* getFilters() {
    const filters = yield select(selectFilters);
    return filters;
}

// Worker Sagas
function* handleFetchDashboard() {
    try {
        const filters = yield call(getFilters);
        const response = yield call(queryMonitoringService.getDashboard, filters);
        yield put(fetchDashboardSuccess(response));
    } catch (error) {
        yield put(fetchDashboardFailure(error.message || 'Failed to fetch dashboard data'));
    }
}

function* handleFetchQueryHistory() {
    try {
        const filters = yield call(getFilters);
        const response = yield call(queryMonitoringService.getQueryHistory, filters);
        yield put(fetchQueryHistorySuccess(response));
    } catch (error) {
        yield put(fetchQueryHistoryFailure(error.message || 'Failed to fetch query history'));
    }
}

function* handleFetchAlerts() {
    try {
        const response = yield call(queryMonitoringService.getAlerts);
        yield put(fetchAlertsSuccess(response));
    } catch (error) {
        yield put(fetchAlertsFailure(error.message || 'Failed to fetch alerts'));
    }
}

function* handleConfigureAlert(action) {
    try {
        const response = yield call(queryMonitoringService.configureAlert, action.payload);
        yield put(configureAlertSuccess(response));
        // Refresh alerts list
        yield put(fetchAlerts());
    } catch (error) {
        yield put(configureAlertFailure(error.message || 'Failed to configure alert'));
    }
}

function* handleUpdateAlert(action) {
    try {
        const response = yield call(queryMonitoringService.updateAlert, action.payload);
        yield put(updateAlertSuccess(response));
        // Refresh alerts list
        yield put(fetchAlerts());
    } catch (error) {
        yield put(updateAlertFailure(error.message || 'Failed to update alert'));
    }
}

function* handleDeleteAlert(action) {
    try {
        yield call(queryMonitoringService.deleteAlert, action.payload);
        yield put(deleteAlertSuccess());
        // Refresh alerts list
        yield put(fetchAlerts());
    } catch (error) {
        yield put(deleteAlertFailure(error.message || 'Failed to delete alert'));
    }
}

function* handleExportReport(action) {
    try {
        const { type, year, month, quarter, format } = action.payload;

        if (type === 'monthly') {
            yield call(queryMonitoringService.exportMonthlyReport, year, month, format);
        } else if (type === 'quarterly') {
            yield call(queryMonitoringService.exportQuarterlyReport, year, quarter, format);
        }

        yield put(exportReportSuccess());
    } catch (error) {
        yield put(exportReportFailure(error.message || 'Failed to export report'));
    }
}

// Watcher Saga
export function* watchQueryMonitoringActions() {
    yield takeLatest(fetchDashboard.type, handleFetchDashboard);
    yield takeLatest(fetchQueryHistory.type, handleFetchQueryHistory);
    yield takeLatest(fetchAlerts.type, handleFetchAlerts);
    yield takeLatest(configureAlert.type, handleConfigureAlert);
    yield takeLatest(updateAlert.type, handleUpdateAlert);
    yield takeLatest(deleteAlert.type, handleDeleteAlert);
    yield takeLatest(exportReport.type, handleExportReport);
}
